import { GuestModel } from 'api-hooks/guest';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody } from 'components/common/drawer/styles';
import { Form } from 'components/elements';
import DocumentTab from 'legacy-modules/master/guest/components/document-tab';
import * as React from 'react';
import { useForm } from 'react-hook-form';

interface Props {
  guest: GuestModel;
  onClose: () => void;
}

export default function DocumentPanel(props: Props) {
  const { guest, onClose } = props;

  const defaultValues = React.useMemo(
    () => ({
      hasPassport: guest?.hasPassport || false,
      insurances: (guest?.insurances || []).map((insurance) => ({
        id: insurance.id,
        number: insurance.number,
        expiredAt: insurance.expiredAt || null,
        files: (insurance.files || []).map((file) => ({
          id: file.id,
          file: file.name,
          url: file.url,
        })),
        issuedAt: insurance.issuedAt || null,
        type: insurance.type,
      })),
      others: (guest?.others || []).map((other) => ({
        id: other.id,
        name: other.name,
        description: other.description,
        files: (other.files || []).map((file) => ({
          id: file.id,
          file: file.name,
          url: file.url,
        })),
      })),
      visas: (guest?.visas || []).map((visa) => ({
        id: visa.id,
        number: visa.number,
        expiredAt: visa.expiredAt || null,
        files: (visa.files || []).map((file) => ({
          id: file.id,
          file: file.name,
          url: file.url,
        })),
        issuedAt: visa.issuedAt || null,
        visaDocumentId: visa.visaDocument.id,
      })),
      apecCard: guest?.hasApecCard
        ? {
            id: guest?.apecCard?.id || undefined,
            name: guest?.apecCard?.name || '',
            passportNumber: guest?.apecCard?.passportNumber || '',
            number: guest?.apecCard?.number || '',
            files: (guest?.apecCard?.files || []).map((file) => ({
              id: file.id,
              file: file.name,
              url: file.url,
            })),
            expiredAt: guest?.apecCard?.expiredAt || null,
            type: guest?.apecCard?.type || '',
            applicationNumber: guest?.apecCard?.applicationNumber || '',
            email: guest?.apecCard?.email || '',
            pin: guest?.apecCard?.pin || '',
          }
        : undefined,
      passport: guest?.hasPassport
        ? {
            id: guest?.passports?.id || undefined,
            number: guest?.passports?.number || '',
            files: (guest?.passports?.files || []).map((file) => ({
              id: file.id,
              file: file.name,
              url: file.url,
            })),
            expiredAt: guest?.passports?.expiredAt || null,
            type: guest?.passports?.type || '',
            givenName: guest.passports.givenName || '',
            dateOfBirth: guest.passports.dateOfBirth || null,
            identifierNumber: guest.passports.identifierNumber || '',
            issueState: guest.passports.issueState || '',
            placeOfBirth: guest.passports.placeOfBirth || '',
            familyName: guest.passports.familyName || '',
            nationality: guest.passports.nationality || '',
            gender: guest.passports.gender || null,
          }
        : undefined,
      vaccines: (guest?.vaccines || []).map((vaccine) => ({
        id: vaccine.id,
        files: (vaccine.files || []).map((file) => ({
          id: file.id,
          file: file.name,
          url: file.url,
        })),
      })),
    }),
    [guest],
  );

  const methods = useForm({
    defaultValues,
  });

  return (
    <Form methods={methods} onSubmit={() => {}} defaultEditable={false}>
      <DrawerHeader title="Documents" onClose={onClose} />
      <DrawerBody>
        <DocumentTab />
      </DrawerBody>
    </Form>
  );
}
